import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

interface Props {
  open: boolean;
  onClose(): void;
  description: string;
  onCancel(): void;
  onSubmit(): void;
}

export default function ConfirmationDialog({
  description,
  onCancel,
  onClose,
  onSubmit,
  open,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent className="p-7">
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onSubmit}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}
